import React from 'react';
import {
  CardCarouselWrapper,
  useRefDimensions,
  useScreenSize,
} from '@avila-tek/ui/src';
import { Category, Company } from '../../../models';
import { screenSizes } from '../../../static';
import SectionRow from '../../sections/SectionRow';

interface CatalogueRowCarouselProps {
  sections?: {
    category: Category;
    allies: Company[];
  }[];
}
function CatalogueRowCarousel({ sections }: CatalogueRowCarouselProps) {
  const [elementsToShow, setElementsToShow] = React.useState(4);
  // carousel cards refs
  const refs = sections.reduce((acc: any, value, index) => {
    acc[index] = React.createRef<HTMLDivElement>();
    return acc;
  }, {});

  const { width: cardWidth } = useRefDimensions(refs[0]);
  const { screenSize } = useScreenSize();

  React.useEffect(() => {
    if (screenSize > screenSizes.XL) {
      setElementsToShow(6);
    } else if (screenSize > screenSizes.LG) {
      setElementsToShow(3);
    } else if (screenSize > screenSizes.SM) {
      setElementsToShow(3);
    } else if (screenSize > screenSizes.XS) {
      setElementsToShow(2);
    } else {
      setElementsToShow(1);
    }
  }, [screenSize]);

  return (
    <div className="w-full   relative z-50">
      <div className="w-full flex flex-col ">
        <CardCarouselWrapper
          cardDimension={cardWidth > 0 ? cardWidth : 240}
          elementsToShow={elementsToShow}
        >
          <div className="flex flex-col">
            <div className="flex flex-col space-y-5">
              {sections?.map((sectionContent) => (
                <SectionRow
                  category={sectionContent.category}
                  allies={sectionContent.allies}
                />
              ))}
            </div>
          </div>
        </CardCarouselWrapper>
      </div>
    </div>
  );
}

export default CatalogueRowCarousel;
